"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = void 0;
const handleError = (error, logger) => {
    if (!logger)
        return;
    if (error instanceof Error) {
        logger.error('%s: %s', error.message, error.stack);
    }
    else {
        logger.error('%s', error);
    }
};
exports.handleError = handleError;
